/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyInput
 */
export interface CompanyInput {
    /**
     * 
     * @type {number}
     * @memberof CompanyInput
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    companyHojinNo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    companyAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    companyGln?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    businessCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    businessCategoryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInput
     */
    tenantId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyInput
     */
    deleteFlg?: boolean | null;
}

/**
 * Check if a given object implements the CompanyInput interface.
 */
export function instanceOfCompanyInput(value: object): value is CompanyInput {
    return true;
}

export function CompanyInputFromJSON(json: any): CompanyInput {
    return CompanyInputFromJSONTyped(json, false);
}

export function CompanyInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInput {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'companyHojinNo': json['company_hojin_no'] == null ? undefined : json['company_hojin_no'],
        'companyAddress': json['company_address'] == null ? undefined : json['company_address'],
        'companyGln': json['company_gln'] == null ? undefined : json['company_gln'],
        'businessCategory': json['business_category'] == null ? undefined : json['business_category'],
        'businessCategoryName': json['business_category_name'] == null ? undefined : json['business_category_name'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
    };
}

export function CompanyInputToJSON(json: any): CompanyInput {
    return CompanyInputToJSONTyped(json, false);
}

export function CompanyInputToJSONTyped(value?: CompanyInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'company_hojin_no': value['companyHojinNo'],
        'company_address': value['companyAddress'],
        'company_gln': value['companyGln'],
        'business_category': value['businessCategory'],
        'business_category_name': value['businessCategoryName'],
        'tenant_id': value['tenantId'],
        'delete_flg': value['deleteFlg'],
    };
}

